import Api from './Api'

export default {
    get(keyword, pageNumber, pageSize, order, idDisciplina, idAula) {
        return Api().get(`avaliacoes?keyword=${keyword}&pageNumber=${pageNumber}&pageSize=${pageSize}&orderColumn=${order.column}&orderSort=${order.sort}&idDisciplina=${idDisciplina}&idAula=${idAula}`);
    },
    getOne(id) {
        return Api().get(`avaliacoes/${id}`);
    },
    add_respostas(data) {
        return Api().post(`avaliacoes/submit`, data);
    },
    update(data) {
        return Api().put(`avaliacoes/${data.id}`, data);
    }
}